<!-- 调店审核 -->
<template>
  <div class="page">
    <p class="p16">IC卡转会员</p>
    <div class="page-head">
      <div class="mains-content br10">
        <div class="member-content-box">
          <div class="member-header space-between">
            <div class="flex-row">
              <el-input v-model="query.keyword" placeholder="请输入ic卡号/手机号码/姓名" maxlength="11" class="mr10"></el-input>
              <el-button type="primary" @click="doData">搜索</el-button>
            </div>
            <el-button type="primary" @click="cardRecord">转卡记录</el-button>
          </div>
          <div class="plr16">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="machShopName" label="来源门店" width="260"></el-table-column>
              <el-table-column prop="username" label="姓名" width="auto"></el-table-column>
              <el-table-column prop="cardLogicNo" label="ic卡号" width="auto"></el-table-column>
              <el-table-column prop="swivelClampStatusCn" label="转卡状态" width="auto"></el-table-column>
              <el-table-column prop="statusCn" label="账号状态" width="auto"></el-table-column>
              <el-table-column prop="userTel" label="手机号码" width="auto"></el-table-column>
              <el-table-column prop="vipLogRestMoney" label="金额" width="auto"></el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="150">
                <template slot-scope="scope">
                  <el-link type="primary"
                    v-if="scope.row.swivelClampStatus == 'unturn' && scope.row.status == 'enable' && scope.row.vipLogRestMoney > 0"
                    @click="orderDetailPage(scope.row)">点击转为电子会员</el-link>
                  <el-link type="primary" v-if="scope.row.swivelClampStatus == 'turn'"
                    @click="DetailPage(scope.row)">详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <detail-set ref="detailSetForm"></detail-set>
    <edit ref="editForm" @change="handleChange"></edit>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import detailSet from "./detail";
import edit from "./edit";
export default {
  data() {
    return {
      query: {
        keyword: "",
        start: 0,
        size: 20
      },
      url: this.$url.icCard.list,
      list: [],
      options: [],
      height: this.$store.getters.MainHeight,
    };
  },
  mixins: [minxin],
  components: { detailSet, edit },
  computed: {},

  created() {
    this.totalCounts();
  },

  methods: {
    back() {
      this.$router.push("/collectMoney");
    },
    orderDetailPage(row) {
      this.$refs["editForm"].$emit("set", row);
    },
    DetailPage(row) {
      this.$refs["detailSetForm"].$emit("set", row);
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    totalCounts() {
      this.$api.post(this.$url.icCard.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => { });
    },
    cardRecord() {
      this.$router.push("/collectMoney/cardRecord")
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

.page-head {
  height: 100%;
}

.mains-content {
  background: #fff;

  .member-header {
    padding: 16px;
    display: flex;
    align-items: center;
  }
}</style>

